import StatusHandler from 'app/shared-components/StatusHandler'
import useGetHsCode from 'app/Apps/OrderManagement/ProformaInvoices/hooks/useGetHsCode'
import requests from 'app/requests/HsCode.requests'

import HsCodeForm from '../HsCodeForm'

export default function HsCodeUpdate({
    id,
    disabled,
}: Readonly<{
    id: number,
    disabled: boolean,
}>) {
    const {
        data,
        isDataReady,
        isFetching,
        invalidate,
        isError,
        error,
    } = useGetHsCode(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <HsCodeForm
                disabled={disabled}
                onSuccess={invalidate}
                onCancel={invalidate}
                data={data}
                request={requests.update({
                    id,
                })}
            />
        </StatusHandler>
    )
}
